import React from 'react'
import PropTypes from 'prop-types'

import pluralize from 'pluralize'
import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import * as helpers from 'Global/Helpers/rugHelpers'
import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

const PictureCardInformation = ({ picture, togglePreview }) => {
  return (
    <Permissions
      permissions={['picture.field.creator', 'picture.field.dateScanned', 'picture.field.pictureSource', 'picture.field.pictureTypes']}
      render={() => (
        <Card.Content extra>
          <List>
            <Permissions
              permissions="picture.field.pictureSource"
              render={() => (
                <CardProperty icon="camera" onClick={togglePreview} popUpContent="Source">
                  {helpers.getPictureSourceString(picture.source)}
                </CardProperty>
              )}
            />

            <Permissions
              permissions="picture.field.dateScanned"
              render={() => (
                <CardProperty icon="calendar check" popUpContent="Date Taken">
                  {getFormattedDateString(picture.date_scanned)}
                </CardProperty>
              )}
            />

            <Permissions
              permissions="picture.field.pictureTypes"
              render={() => (
                <CardProperty icon="file image outline" popUpContent="Number of Picture Types">
                  {`${picture.files.length} picture ${pluralize('type', picture.files.length)}`}
                </CardProperty>
              )}
            />

            <Permissions
              permissions="picture.field.creator"
              render={() => (
                <CardProperty icon="user" popUpContent="Taken by">
                  {`${picture.creator.firstName} ${picture.creator.lastName}`}
                </CardProperty>
              )}
            />
          </List>
        </Card.Content>
      )}
    />
  )
}

PictureCardInformation.propTypes = {
  picture: PropTypes.object.isRequired,
  togglePreview: PropTypes.func.isRequired,
}

export default PictureCardInformation
